
export const ROOT_PATH_APP = '';

export const AppRoutes = {
  ROOT: `${ROOT_PATH_APP}/`,
  PROPERTY_TYPE: `${ROOT_PATH_APP}/vrsta-nekretnine`,
  WEBSHOP: {
    PROPERTY_INFO: `${ROOT_PATH_APP}/webshop/detalji-nekretnine`,
    CUSTOMER: `${ROOT_PATH_APP}/webshop/osnovni-podaci`,
    RISKS: `${ROOT_PATH_APP}/webshop/detalji-rizika`,
    OFFERS: `${ROOT_PATH_APP}/webshop/ponude`,
    OFFER: `${ROOT_PATH_APP}/webshop/ponuda`,
    CONTACT: `${ROOT_PATH_APP}/webshop/kontakt`,
    OFFER_CONFIRMATION: `${ROOT_PATH_APP}/webshop/potvrda-podataka`,
    PAYMENT: `${ROOT_PATH_APP}/webshop/placanje/:soId/:offerId`,
    CHECKOUT_SUCCESS: `${ROOT_PATH_APP}/webshop/placanje-uspjeh`,
    CHECKOUT_FAILURE: `${ROOT_PATH_APP}/webshop/placanje-neuspjeh`,
    CHECKOUT_SUCCESS_OFFLINE: `${ROOT_PATH_APP}/webshop/placanje-uspjeh-o`,
  },
  FUNNEL: {
    RISKS: `${ROOT_PATH_APP}/funnel/detalji-rizika`,
    PROPERTY_INFO: `${ROOT_PATH_APP}/funnel/detalji-nekretnine`,
    CUSTOMER: `${ROOT_PATH_APP}/funnel/osnovni-podaci`,
    CONTACT: `${ROOT_PATH_APP}/funnel/kontakt`
  },
  CHECKOUT: {
    OFFERS: `${ROOT_PATH_APP}/checkout/ponude/:soId`,
    OFFER_CONFIRMATION: `${ROOT_PATH_APP}/checkout/potvrda-podataka/:offerId`,
    PAYMENT: `${ROOT_PATH_APP}/checkout/placanje/:soId/:offerId`,
    CHECKOUT_SUCCESS: `${ROOT_PATH_APP}/checkout/placanje-uspjeh`,
    CHECKOUT_FAILURE: `${ROOT_PATH_APP}/checkout/placanje-neuspjeh`,
    CHECKOUT_SUCCESS_OFFLINE: `${ROOT_PATH_APP}/checkout/placanje-uspjeh-o`,
    GENERAL_TRANSFER_PAYMENT_SENT: `${ROOT_PATH_APP}/checkout/placanje-poslano/:offerId`,
    CHECKOUT_SUCCESS_GENERAL_TRANSFER: `${ROOT_PATH_APP}/checkout/placanje-uplatnica/:offerId`,
  },
  TERMS_AND_CONDITIONS: `${ROOT_PATH_APP}/uvijeti-osiguranja/:id`,
}

// Step configuration for Header TitleSection
export interface StepConfig {
  step?: number;
  title?: string;
  subtitle?: string;
  disclaimer?: string;
  stepsHeader?: boolean;
  totalSteps?: number;
}

export const RouteStepConfig: Record<string, StepConfig> = {
  [AppRoutes.ROOT]: { step: 1, title: 'pages.steps.whatToInsure' },
  [AppRoutes.PROPERTY_TYPE]: { step: 1, title: 'pages.steps.whatToInsure' },
  [AppRoutes.WEBSHOP.PROPERTY_INFO]: { step: 2, title: 'pages.steps.propertyDataApartment' },
  [AppRoutes.WEBSHOP.CUSTOMER]: { step: 3, title: 'pages.steps.yourData' },
  [AppRoutes.WEBSHOP.RISKS]: { step: 4, title: 'pages.steps.insuranceByMeasure', subtitle: 'pages.steps.insuranceByMeasureSubtitle' },
  [AppRoutes.WEBSHOP.OFFERS]: { step: 5, title: 'pages.offers.title', subtitle: 'pages.offers.subtitle', disclaimer: 'pages.offers.disclaimer' },
  [AppRoutes.WEBSHOP.OFFER]: { step: 6, title: 'pages.steps.yourChoice', subtitle: 'pages.steps.yourChoiceSubtitle' },
  [AppRoutes.WEBSHOP.OFFER_CONFIRMATION]: { step: 7, title: 'pages.steps.enterPolicyData' },
  [AppRoutes.WEBSHOP.PAYMENT]: { step: 8, title: 'pages.steps.payment', subtitle: 'pages.steps.paymentSubtitle' },
  [AppRoutes.WEBSHOP.CHECKOUT_SUCCESS]: { step: 3, totalSteps: 3 },
  [AppRoutes.WEBSHOP.CHECKOUT_FAILURE]: { step: 3, totalSteps: 3 },
  [AppRoutes.WEBSHOP.CONTACT]: { step: 7, totalSteps: 7 },
  [AppRoutes.FUNNEL.RISKS]: { step: 2, title: 'pages.steps.insuranceByMeasure', subtitle: 'pages.steps.insuranceByMeasureSubtitle', totalSteps: 5 },
  [AppRoutes.FUNNEL.PROPERTY_INFO]: { step: 3, title: 'pages.steps.propertyDataHouse', totalSteps: 5 },
  [AppRoutes.FUNNEL.CUSTOMER]: { step: 4, title: 'pages.steps.yourData', totalSteps: 5 },
  [AppRoutes.FUNNEL.CONTACT]: { step: 5, totalSteps: 5 },
  [AppRoutes.CHECKOUT.OFFERS]: { step: 1, totalSteps: 3 },
  [AppRoutes.CHECKOUT.OFFER_CONFIRMATION]: { step: 2, totalSteps: 3 },
  [AppRoutes.CHECKOUT.PAYMENT]: { step: 3, totalSteps: 3 },
  [AppRoutes.CHECKOUT.CHECKOUT_SUCCESS]: { step: 3, totalSteps: 3 },
  [AppRoutes.CHECKOUT.CHECKOUT_FAILURE]: { step: 3, totalSteps: 3 },
  [AppRoutes.TERMS_AND_CONDITIONS]: { title: 'pages.steps.termsTitle' },
}

// Get step config for current path (handles dynamic routes with :params)
export const getStepConfig = (pathname: string): StepConfig | null => {
  // Direct match first
  if (RouteStepConfig[pathname]) {
    return RouteStepConfig[pathname];
  }

  // Check for paths with dynamic segments (e.g., /so/:soId)
  for (const [route, config] of Object.entries(RouteStepConfig)) {
    // Check if pathname starts with the route (for routes with /so/:soId suffix)
    const cleanRoute = route.split('/:');

    if (pathname.startsWith(cleanRoute[0] + '/')) {
      return config;
    }
  }

  return null;
}
